var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-alert',_vm._g(_vm._b({attrs:{"type":_vm.type,"border":"top","dense":""}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }